import { Record } from 'immutable';
import { Base } from './base';

const resource = 'supply_invites';

class SupplyInvite extends Base(Record({
    id: null,
    accepted: false,
    code: '',
    invited_email: '',
    invited_name: '',
    invited_vendor_id: null,
    type: '', // supplier or producer
    inserted_at: null,
    vendor_id: null
  })) {
    $create(id) {
      return this.api.post({
        resource: resource
      }, this.api.payload(resource, id ? this.set('vendor_id', id) : this))
      .then(res => this.dispatch(this.actions.receiveEntity(res.data, 'supplyInvites')));
    }

    $delete() {
      return this.api.delete({
        id: this.id,
        resource: resource
      });
    }

    $get(id, code) {
      if (this.vendor_id) id = this.vendor_id;

      if (code) {
        return this.api.get({
          resource: resource + '?filter[code]=' + code
        })
        .then(res => this.dispatch(this.actions.receiveEntities(res.data, 'supplyInvites')));
      }

      return this.api.get({
        resource: resource + '?filter[vendor_id]=' + id
      })
      .then(res => this.dispatch(this.actions.receiveEntities(res.data, 'supplyInvites')))
      .then(res => this.api.get({
        resource: resource + '?filter[invited_vendor_id]=' + id
      }))
      .then(res => this.dispatch(this.actions.receiveEntities(res.data, 'supplyInvites')));
    }

    $put() {
      return this.api.put({
        id: this.id,
        resource: resource
      }, this.api.payload(resource, this))
      .then(res => this.dispatch(this.actions.receiveEntity(res.data, 'supplyInvites')));
    }
  }

export default SupplyInvite;



// WEBPACK FOOTER //
// ./src/records/supply-invite.js